<template>
  <v-sheet v-if="item">
    <v-list class="pb-0">
      <v-list-item class="py-3">
        <v-list-item-avatar size="40">
          <ProxyImage :src="item.primary_picture" alt="Item"/>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
          <v-list-item-subtitle>
            <div class="blue-grey--text font-weight-bold" v-if="item.plan.sell_on_credit === 1">
              {{ item.plan.monthly_amount | currency }} for {{ item.plan.no_of_months }} month(s)
            </div>
            <div class="blue-grey--text font-weight-bold mb-3" v-if="item.plan.sell_on_credit === 0">
              {{ item.plan.upfront_amount | currency }} outright
            </div>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="remove(item)" color="red" icon v-bind="attrs" v-on="on">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Remove item from cart</span>
          </v-tooltip>
        </v-list-item-action>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item class="px-6 py-10">
        <div class="fill-width d-flex justify-space-between align-center">
          <p class="text-title grey--text">Edit quantity</p>
          <div>
            <v-text-field :value="item.plan.quantity" dense outlined readonly style="width: 150px">
              <v-icon @click="$store.commit('cart/decreaseQuantity', item.id)" color="red" slot="prepend">
                mdi-minus
              </v-icon>
              <v-icon @click="$store.commit('cart/increaseQuantity', item.id)" color="green" slot="append-outer">
                mdi-plus
              </v-icon>
            </v-text-field>
          </div>
        </div>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-card-actions class="px-6">
      <v-btn @click="$emit('close')" color="red" text>Close</v-btn>
      <v-spacer></v-spacer>
      <v-btn :to="`/${$store.state.merchant.slug}/item/${item.slug}`" text>
        View Product
      </v-btn>
    </v-card-actions>
  </v-sheet>
</template>
<script>
	import ProxyImage from "../ProxyImage";

	export default {
		name: 'CartListItemContent',
		components: { ProxyImage },
		props: {
			item: {
				required: true
			},
		},
		methods: {
			remove(item) {
				this.$store.commit('cart/removeItem', item.id);
				this.$emit('close');
			}
		}
	}
</script>
